import { StyleSheet, Platform } from 'react-native'
import * as colors from '../../config/colors'
import * as v from '../../config/variables'

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: v.SPACE_MD + v.SPACE_SM,
    paddingVertical: v.SPACE_MD,
  },
  bulletStyle: {
    paddingLeft: 0,
    // paddingLeft: 0
    // marginTop: 10,
    // position: 'absolute',
    // top: 0,
    // left: -10,
    color: colors.blue,
  },
  bulletContainerStyle: {
    marginRight: v.SPACE_SM,
  },

  // BlockChildrenOverview
  iconContainer: {
    marginTop: Platform.OS === 'android' ? 4 : 0,
    width: 38,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  outerBox: {
    marginTop: v.SPACE_XS,
  },
  questionText: {
    textAlign: 'center',
  },
  actionBox: {
    marginVertical: v.SPACE_SM,
    alignItems: 'center',
  },
  disclaimerContainer: {
    marginVertical: v.SPACE_MD,
    paddingHorizontal: v.SPACE_SM,
  },
  disclaimerText: {
    textAlign: 'center',
    color: colors.grayDark,
    fontSize: v.FONT_SIZE_SMALL,
  },
})

/**
 * Deprecated text styles
 */
// const tagStyles = {
//   // HTML
//   h1: {
//     fontWeight: 'bold',
//     fontFamily: 'NunitoSans_700Bold',
//     fontSize: v.FONT_SIZE_H1,
//   },
//   h2: {
//     fontWeight: 'bold',
//     fontFamily: 'NunitoSans_700Bold',
//     color: colors.blue,
//     // fontFamily: v.FONT_FAMILY_BASE,
//     fontSize: v.FONT_SIZE_H2,
//     marginTop: v.SPACE_SM,
//     marginBottom: v.SPACE_SM,
//   },
//   h3: {
//     fontFamily: v.FONT_FAMILY_BOLD,
//     fontSize: v.FONT_SIZE_H3,
//     color: colors.blue,
//   },
//   h4: {
//     fontFamily: v.FONT_FAMILY_BASE,
//     fontSize: v.FONT_SIZE_H4,
//   },
//   h5: {
//     fontFamily: v.FONT_FAMILY_BASE,
//     fontSize: v.FONT_SIZE_H4,
//   },
//   p: {
//     fontFamily: v.FONT_FAMILY_BASE,
//     fontSize: v.FONT_SIZE_BASE,
//     marginBottom: v.SPACE_SM,
//     // paddingBottom: 0
//   },
//   a: {
//     fontFamily: v.FONT_FAMILY_BASE,
//     fontSize: v.FONT_SIZE_BASE,
//   },
//   strong: {
//     fontSize: v.FONT_SIZE_BASE,
//     fontWeight: 'bold',
//     fontFamily: 'NunitoSans_700Bold',
//   },
//   li: {
//     fontSize: v.FONT_SIZE_BASE,
//     fontFamily: v.FONT_FAMILY_BASE,
//     // marginLeft: 10,
//     // borderWidth: 2,
//     // marginBottom: v.SPACE_MD
//   },
//   div: {},
//   ol: {},
//   ul: {
//     paddingLeft: v.SPACE_SM,
//     marginTop: v.SPACE_XS,
//   },
// }

export default styles
export { styles }
